import { type HTMLAttributes } from 'react';

import { GlobalHotkeysFocusShell } from '@/components/layoutAndProvidersWrapper/GlobalHotkeysFocusShell.tsx';
import { GlobalModalsProvider } from '@/components/layoutAndProvidersWrapper/GlobalModalsProvider.tsx';
import { AppCoreProviders, GamepadProvider } from '@/providers';

export const LayoutAndProvidersWrapper = ({ children }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <AppCoreProviders>
      <GamepadProvider>
        <GlobalModalsProvider>
          <GlobalHotkeysFocusShell>{children}</GlobalHotkeysFocusShell>
        </GlobalModalsProvider>
      </GamepadProvider>
    </AppCoreProviders>
  );
};
